
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerFlag as ObiBeaconTowerFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-flag.js';
 
 
 

 
 export const ObiBeaconTowerFlag = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-flag',
   elementClass: ObiBeaconTowerFlagElement,
   events: {
     
   }
  });
 
 